import { CashRegisterPaymentMethod, MethodPaymentType } from "@prisma/client";

type OrderWithPayment = {
  onlineCardPayment: unknown;
  cashRegisterPayment: { paymentMethod: CashRegisterPaymentMethod } | null;
};

export const getPaymentMedium = (order: OrderWithPayment): CashRegisterPaymentMethod | null => {
  if (order.onlineCardPayment) return CashRegisterPaymentMethod.card;
  if (order.cashRegisterPayment) return order.cashRegisterPayment.paymentMethod;
  return null;
};

export const PAYMENT_METHOD_LABELS: Record<CashRegisterPaymentMethod, string> = {
  cash: "Espèces",
  card: "Carte bancaire",
  bankDraft: "Chèques",
};

export const PAYMENT_METHOD_LABELS_UPPERCASE: Record<CashRegisterPaymentMethod, string> = {
  cash: "ESPECES",
  card: "CARTE BANCAIRE",
  bankDraft: "CHEQUES",
};

export const getPaymentMethodLabel = (
  method: CashRegisterPaymentMethod,
  uppercase = false,
): string => {
  const labels = uppercase ? PAYMENT_METHOD_LABELS_UPPERCASE : PAYMENT_METHOD_LABELS;
  return labels[method] ?? method;
};

// Keys intentionally match both CashRegisterPaymentMethod and MethodPaymentType members.
export const SALES_PAYMENT_METHOD_LABELS = {
  card: "CB",
  cash: "Espèces",
  bankDraft: "Chèques",
  transfer: "Virement",
} as const satisfies Record<CashRegisterPaymentMethod | MethodPaymentType, string>;

export const SALES_PAYMENT_METHOD_UNKNOWN_LABEL = "-";

type OrderWithSalesPayment = {
  onlineCardPayment: unknown;
  cashRegisterPayment: { paymentMethod: CashRegisterPaymentMethod } | null;
  proPaymentMethod: { paymentType: MethodPaymentType } | null;
};

// Payment relations are mutually exclusive (each FK is @unique on Order).
export const getSalesPaymentMethodLabel = (order: OrderWithSalesPayment): string => {
  if (order.onlineCardPayment) return SALES_PAYMENT_METHOD_LABELS.card;
  if (order.cashRegisterPayment) {
    return SALES_PAYMENT_METHOD_LABELS[order.cashRegisterPayment.paymentMethod];
  }
  if (order.proPaymentMethod) {
    return SALES_PAYMENT_METHOD_LABELS[order.proPaymentMethod.paymentType];
  }
  return SALES_PAYMENT_METHOD_UNKNOWN_LABEL;
};
